export default "__VITE_ASSET__CRqOvlKs__"